<template>
  <div>
    <div class="d-flex align-items-center py-1 ps-2 base-selector-header-background">
      <div class="fw-bold px-2">
        {{ trans('subscription.classification_config.selectors.group.group_type') }}
      </div>
      <SelectorSelectOperator
        v-if="groupCategory"
        v-model="groupCategoryLocal"
        :selector-type="'group'"
        :operator-type="groupCategoryConstant"
        @input="changeOperatorGroupCategory"
      />
    </div>
    <div class="ms-4 py-1 m-2 condition-border">
      <SelectorConfigGroup
        v-if="groupCategory === groupCategoryConstant.config"
        :selector="selector"
        @input="changePropertyValueMultiSelect"
      />
      <SelectorDatabaseGroup
        v-else
        :selector="selector"
        @input="changePropertyValueMultiSelect"
      />
    </div>
  </div>
</template>

<script>
import SelectorConfigGroup from '@/employees/components/Selector/SelectorConfigGroup'
import SelectorDatabaseGroup from '@/employees/components/Selector/SelectorDatabaseGroup'
import selectorMixin from '@/employees/components/Selector/utilities/mixins/selectorMixin'
import { GROUP_CATEGORY, SELECTOR_TYPE } from '@/constants'
import { mapState } from 'vuex'
export default {
  name: 'SelectorGroup',
  components: {
    SelectorDatabaseGroup,
    SelectorConfigGroup,
  },
  mixins: [selectorMixin],
  inject: ['selectorContext', 'programId'],
  props: {
    selectorReference: {
      required: true,
      type: String,
    },
    selector: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      select: [],
      selectorPropertyConstant: SELECTOR_TYPE,
      groupCategoryConstant: GROUP_CATEGORY,
      groupCategoryLocal: null,
    }
  },
  computed: {
    ...mapState({
      groupCategory (state) {
        if (state.selectors.groupOperators.hasOwnProperty(this.selectorReference)) {
          return state.selectors.groupOperators[this.selectorReference]
        }
        return null
      },
    }),
  },
  created () {
    //* already has a group
    if (this.selector.group) {
      if (!this.selector.group?.id) {
        this.select = null
        this.setGroupOperator('config')
      } else {
        this.select = []
        this.setGroupOperator('database')
      }
    //* already has no group
    } else {
      if (this.groupCategory === null) {
        if (this.selectorContext.groupNames.length > 0) {
          this.select = null
          this.setGroupOperator('config')
        } else {
          this.select = []
          this.setGroupOperator('database')
        }
      }
    }
    this.groupCategoryLocal = this.groupCategory
  },
  methods: {
    changeOperatorGroupCategory (newValue) {
      this.selectorPropertyValueChange(this.selectorReference, this.selectorPropertyConstant.group, null)
      if (newValue === this.groupCategoryConstant.config) {
        this.select = null
      } else {
        this.select = []
      }
      this.setGroupOperator(newValue)
    },
    changePropertyValueMultiSelect (newValue) {
      this.selectorPropertyValueChange(this.selectorReference, this.selectorPropertyConstant.group, newValue)
    },
    setGroupOperator (groupCategory) {
      this.$store.dispatch('set_group_operator', { reference: this.selectorReference, groupCategory })
    },
  },
}
</script>

<style scoped>
.base-selector-header-background {
  background-color: rgba(0, 0, 0, 0.3);
}
/deep/
.form-control {
  width: 75%;
}
/deep/
.col-sm-2 {
  float: none;
}
/deep/
.col-sm-10 {
  float: none;
}
</style>
